<template>
  <ZigzagServiceLayout
    mainTitle="Diverse Care Now Education"
    mainDescription="Comprehensive training programs to launch your career in healthcare."
    :sections="sections"
    :hideBookButton="true"
  />
</template>

<script>
import ZigzagServiceLayout from '../../../components/ZigzagServiceLayout.vue';

export default {
  name: 'EducationContentEn',
  components: {
    ZigzagServiceLayout,
  },
  data() {
    return {
      sections: [
        {
          label: 'PHLEBOTOMY PROGRAM',
          title: 'Phlebotomy Technician Diploma',
          subtitle: '165 Clock Hours of Comprehensive Training',
          paragraphs: [
            "Diverse Care Now Education offers a comprehensive 165-hour Phlebotomy Technician Diploma Program designed to provide students with the knowledge, practical skills, and hands-on training needed for phlebotomy.",
            "The program combines classroom instruction with supervised practical training, including blood collection techniques, venipuncture, capillary puncture, specimen handling, infection control, safety procedures, patient identification, and professional standards."
          ],
          list: [
            "Blood collection techniques & venipuncture",
            "Capillary puncture & specimen handling",
            "Infection control & safety procedures",
            "Patient identification & professional standards"
          ],
          image: '/images/services/education-classroom.png'
        },
        {
          label: 'CERTIFICATION',
          title: 'AMCA Certification Preparation',
          subtitle: 'Your pathway to a rewarding healthcare career.',
          paragraphs: [
            "Upon successful completion of the 165-clock-hour program, students receive a Phlebotomy Technician Diploma and are prepared to pursue the AMCA certification examination.",
            "Our program provides the foundation you need to enter the healthcare workforce with confidence and competence."
          ],
          list: [
            "Program: Phlebotomy Technician Diploma",
            "Length: 165 Clock Hours",
            "Institution: Diverse Care Now Education",
            "Training: Classroom & Hands-On Clinical Skills",
            "Certification Preparation: AMCA Phlebotomy Certification Exam"
          ],
          image: '/images/services/education-certification.png'
        }
      ]
    };
  }
};
</script>
